import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { HubInAppBrowserHost } from "@/components/HubInAppBrowser";
import { AuthProvider } from "@/lib/auth";
import { installExternalLinkClickHandler } from "@/lib/openExternalLink";
import { captureSlackClaim } from "@/lib/slackCustomer";
import "./index.css";

const stored = window.localStorage.getItem("atw-hub-theme");
const dark =
  stored === "dark" ||
  (stored !== "light" && window.matchMedia("(prefers-color-scheme: dark)").matches);
document.documentElement.dataset.theme = dark ? "dark" : "light";
document.documentElement.classList.toggle("dark", dark);
document.documentElement.style.colorScheme = dark ? "dark" : "light";
// Bust poisoned CF edge cache for prior tip JS hash (SPA HTML served as immutable).
document.documentElement.dataset.cdnTip = "20261005t1200";

// Tip 140: http(s) links open in a new tab and focus it (SPA routes stay in-app).
installExternalLinkClickHandler(document);

// Tip 148: keep an ATW Hub for Slack install code before sign-in redirects drop the URL hash.
captureSlackClaim();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <HubInAppBrowserHost />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
